export default function installAppcues () {
  if (window.gon.current_user_id) {
    window.Appcues.identify(window.gon.current_user_id, { // Unique identifier for current user
      email: window.gon.current_user_email, // Current user's email
    });
  } else {
    window.Appcues.anonymous();
  }
}



// WEBPACK FOOTER //
// ./src/control/app-cues/index.js